var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer redfooter"},[_c('Credits'),_c('div',{staticClass:"content has-text-centered"},[_c('p',[_c('font',{attrs:{"color":"white"}},[_vm._v("© 2020 Virtual Red - Todos os direitos reservados.")])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }